<template>
  <div>
    <div class="column gap-s mb-20">
      <InfoTextBlock label-text="Материал" :text="getMaterialName" />
      <InfoTextBlock label-text="d пров." :text="dWire" />
      <InfoTextBlock label-text="Кол-во изделий" :text="qty" />
    </div>
    <div v-for="(row, idx) in value" :key="idx" class="section--gray column gap-s mb-10">
      <div class="d-flex gap-10 ai-fe">
        <VInput
          v-model="row.length"
          label="Метраж:"
          disabled />
        <VInput
          v-model="row.count"
          label="Кол-во прутков, шт.:"
          required
          :pattern="/^\d+$/"
          :custom-validation="row.reserved_count ? () => validationCount(row) : null"
          @input="updateWeightDirty(row)"
        >
          <Validation for="required" />
          <Validation for="pattern">Только целое число</Validation>
          <Validation for="customValidation">Кол-во прутков не может быть больше {{ row.reserved_count }}</Validation>
        </VInput>
      </div>
      <div class="d-flex gap-10 ai-fe">
        <VInput
          v-model="row.amount"
          label="Брали в резерве, КГ:"
          disabled
        />
        <VInput
          v-model="row.weight_dirty"
          label="Общий вес изделий:"
          :pattern="/^[0-9]\d*[.,]?(\d{0,3}?)$/"
          required
        >
          <Validation for="required" />
          <Validation for="pattern">Только цифры с точностью до тысячных</Validation>
        </VInput>
        <div class="d-flex gap-s mt-5">
          <VButton
            icon="remove"
            size="md"
            :disabled="value.length === 1"
            @click.native="removeReserveRow(idx)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfoTextBlock from '@/components/ui/AppInfoTextBlock.vue'
import Validation from '@/components/Form/Validation.vue'
import VInput from '@/components/Form/Vinput/VInput.vue'
import VButton from '@/components/simple/button/VButton.vue'
import { fixedNumberCopy } from '@/utils/number'

export default {
  name: 'ConsignmentFormWeightDirty',
  components: {
    VButton,
    VInput,
    Validation,
    InfoTextBlock
  },

  props: {
    consignment: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    qty: {
      type: [Number, String],
      default: '-'
    },
    value: {
      type: Array,
      default: null
    }
  },
  computed: {
    getMaterialName () {
      return this.position?.material?.name ?? '-'
    },

    dWire () {
      return this.position?.d_wire ?? '-'
    }
  },

  methods: {
    // Удаление строки
    removeReserveRow (idx) {
      if (this.value.length > 1) this.value.splice(idx, 1)
    },

    // Расчёт веса в зависимости от количества
    updateWeightDirty (row) {
      if (row?.warehouse_material?.weight_by_one && row?.count) {
        const weight = (+row.warehouse_material.weight_by_one * +row.count) || 0
        row.weight_dirty = fixedNumberCopy(weight, 3)
      }
    },

    validationCount (row) {
      return +row?.count <= row?.reserved_count
    }
  }
}
</script>
